import {
  Autocomplete,
  Box,
  Chip,
  DatePicker,
  FiltrosChips,
  FiltrosDrawer,
  FiltrosGrupoBotoes,
  FiltrosSecao,
  TextField,
} from "../../../../../components";
import { value } from "../../../../../helpers";
import { formatDate } from "../../../../../utils";
import {
  PERIODO_PRESETS,
  REGIMES,
  formatarDataChip,
  intervaloPreset,
  labelPlanoFinanceiro,
} from "../despesas-por-plano-financeiro";

const POPPER_SX = { sx: { zIndex: 9000 } };

function chipsAtivos(filtros, acessosEmpresas, aplicar) {
  const remover = (patch) => aplicar({ ...filtros, ...patch });
  const chips = [
    {
      key: "regime",
      icon: "ph-scales",
      label: REGIMES.find((r) => r.value === filtros.regime)?.label,
    },
    {
      key: "periodo",
      icon: "ph-calendar-blank",
      label: `${formatarDataChip(filtros.dataInicio)} – ${formatarDataChip(
        filtros.dataFim,
      )}`,
    },
  ];
  if (acessosEmpresas.length > 0) {
    filtros.empresas?.forEach((e) =>
      chips.push({
        key: `emp-${e.id}`,
        icon: "ph-buildings",
        label: e.razaoSocial,
        onDelete: () =>
          remover({ empresas: filtros.empresas.filter((x) => x.id !== e.id) }),
      }),
    );
  }
  if (filtros.centroCusto) {
    chips.push({
      key: "centro",
      icon: "ph-target",
      label: filtros.centroCusto.descricao,
      onDelete: () => remover({ centroCusto: null }),
    });
  }
  if (filtros.planoFinanceiro) {
    chips.push({
      key: "plano",
      icon: "ph-folders",
      label: labelPlanoFinanceiro(filtros.planoFinanceiro),
      onDelete: () => remover({ planoFinanceiro: null }),
    });
  }
  return chips;
}

function DespesasFiltros({
  filtros,
  filtrosPadrao,
  onAplicar,
  listas,
  acessosEmpresas,
  draft,
  setDraft,
  open,
  setOpen,
}) {
  const setCampo = (campo, valor) =>
    setDraft((prev) => ({ ...prev, [campo]: valor }));

  const aplicar = () => {
    onAplicar(draft);
    setOpen(false);
  };

  const onChangeData = (campo, date) =>
    setCampo(
      campo,
      date && date !== "Invalid Date" ? formatDate.toSend(date) : "",
    );

  return (
    <>
      <FiltrosChips chips={chipsAtivos(filtros, acessosEmpresas, onAplicar)} />

      <FiltrosDrawer
        open={open}
        onClose={() => setOpen(false)}
        onLimpar={() => setDraft(filtrosPadrao)}
        onAplicar={aplicar}
      >
        {acessosEmpresas.length > 0 && (
          <FiltrosSecao titulo="Unidades">
            <Autocomplete
              multiple
              filterSelectedOptions
              options={acessosEmpresas}
              disableCloseOnSelect
              getOptionLabel={(opt) => opt?.razaoSocial ?? ""}
              isOptionEqualToValue={(opt, val) =>
                String(opt?.id) === String(val?.id)
              }
              value={draft.empresas ?? []}
              onChange={(_, val) => setCampo("empresas", val)}
              slotProps={{ popper: POPPER_SX }}
              renderInput={(params) => (
                <TextField {...params} label="Unidade(s)" />
              )}
            />
          </FiltrosSecao>
        )}

        <FiltrosSecao
          titulo="Regime"
          descricao={REGIMES.find((r) => r.value === draft.regime)?.descricao}
        >
          <FiltrosGrupoBotoes
            opcoes={REGIMES}
            ativo={(opcao) => draft.regime === opcao.value}
            onSelecionar={(opcao) => setCampo("regime", opcao.value)}
          />
        </FiltrosSecao>

        <FiltrosSecao titulo="Período" gap={1.5}>
          <Box display="flex" gap={1}>
            <DatePicker
              label="Data Inicial"
              format="dd/MM/yyyy"
              value={value.date(draft.dataInicio)}
              onChange={(date) => onChangeData("dataInicio", date)}
              sx={{ width: "100%" }}
            />
            <DatePicker
              label="Data Final"
              format="dd/MM/yyyy"
              value={value.date(draft.dataFim)}
              onChange={(date) => onChangeData("dataFim", date)}
              sx={{ width: "100%" }}
            />
          </Box>
          <Box display="flex" flexWrap="wrap" gap={0.75}>
            {PERIODO_PRESETS.map((preset) => (
              <Chip
                key={preset.label}
                size="small"
                clickable
                variant="outlined"
                label={preset.label}
                onClick={() =>
                  setDraft((prev) => ({ ...prev, ...intervaloPreset(preset) }))
                }
              />
            ))}
          </Box>
        </FiltrosSecao>

        <FiltrosSecao titulo="Detalhamento">
          <Autocomplete
            options={listas.centrosCusto}
            noOptionsText="Sem opções"
            getOptionLabel={(opt) => opt?.descricao ?? ""}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={draft.centroCusto}
            onChange={(_, val) => setCampo("centroCusto", val)}
            slotProps={{ popper: POPPER_SX }}
            renderInput={(params) => (
              <TextField {...params} label="Centro de Custo" />
            )}
          />

          <Autocomplete
            options={listas.planosFinanceiros}
            noOptionsText="Sem opções"
            getOptionLabel={(opt) => labelPlanoFinanceiro(opt)}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            value={draft.planoFinanceiro}
            onChange={(_, val) => setCampo("planoFinanceiro", val)}
            slotProps={{ popper: POPPER_SX }}
            renderInput={(params) => (
              <TextField {...params} label="Plano Financeiro" />
            )}
          />
        </FiltrosSecao>
      </FiltrosDrawer>
    </>
  );
}

export default DespesasFiltros;
